import React, { useState } from 'react';
import { Button, Upload } from 'antd';
import { GetProp, UploadProps } from 'antd';
import { DeleteOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';

type CouponUploadProps = {
  value?: string;
  onChange?: (value: string) => void;
};

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

const CouponUpload = ({
  value: imageUrl = '',
  onChange: setImageUrl = () => undefined,
}: CouponUploadProps) => {
  const [loading, setLoading] = useState(false);

  const getBase64 = (img: FileType, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result as string));
    reader.readAsDataURL(img);
  };

  const handleChange: UploadProps['onChange'] = (info) => {
    setLoading(true);
    getBase64(info.file.originFileObj as FileType, (url) => {
      setLoading(false);
      setImageUrl(url);
    });
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type='button'>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const beforeUpload = (file: FileType) => {
    return true;
  };

  return (
    <Upload
      name='avatar'
      listType='picture-card'
      className='avatar-uploader'
      showUploadList={false}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      accept='image/*'
    >
      {imageUrl ? (
        <img src={imageUrl} alt='avatar' style={{ width: '200px', height: '150px' }} />
      ) : (
        uploadButton
      )}
      {imageUrl && (
        <Button
          onClick={(e) => [e.stopPropagation(), setImageUrl('')]}
          type='dashed'
          className='btn-trash'
        >
          <DeleteOutlined style={{ fontSize: 20 }} />
        </Button>
      )}
    </Upload>
  );
};
export default CouponUpload;
